import { Provider } from "@/components/excel/schema/definiens/provider";
import { AreaNameProvider } from "@/components/excel/schema/label/provider/area";
import { DateTimeNameProvider } from "@/components/excel/schema/label/provider/date-time";
import { OtherNameProvider } from "@/components/excel/schema/label/provider/other";

export const NameProvider: { [key: number]: Provider } = {
  ...AreaNameProvider,
  ...DateTimeNameProvider,
  ...OtherNameProvider,
};
